module.exports = __webpack_public_path__ + "img/blackice.25171229.png";